module.exports = __webpack_public_path__ + "static/img/add.de159e5f.svg";